/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Templates_Confirm_Apply_DescriptionInputs */



/**
* | output |
* | --- |
* | "Apply template \"{name}\"? This will replace your current instructions." |
*
* @param {Templates_Confirm_Apply_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const templates_confirm_apply_description = /** @type {((inputs: Templates_Confirm_Apply_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Confirm_Apply_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vorlage "${i?.name}" anwenden? Ihre aktuellen Anweisungen werden dadurch ersetzt.`)
	return /** @type {LocalizedString} */ (`Apply template "${i?.name}"? This will replace your current instructions.`)
});